export var BioreactorParameterValue;
(function (BioreactorParameterValue) {
    BioreactorParameterValue["MinVolume"] = "MinVolume";
    BioreactorParameterValue["MaxVolume"] = "MaxVolume";
    BioreactorParameterValue["VolumeRange"] = "VolumeRange";
    BioreactorParameterValue["MinGassingRateAbs"] = "MinGassingRateAbs";
    BioreactorParameterValue["MaxGassingRateAbs"] = "MaxGassingRateAbs";
    BioreactorParameterValue["GassingRateRangeProp"] = "GassingRateRangeProp";
    BioreactorParameterValue["GassingRateRangeAbs"] = "GassingRateRangeAbs";
    BioreactorParameterValue["MinStirSpeed"] = "MinStirSpeed";
    BioreactorParameterValue["MaxStirSpeed"] = "MaxStirSpeed";
    BioreactorParameterValue["StirSpeedRange"] = "StirSpeedRange";
})(BioreactorParameterValue || (BioreactorParameterValue = {}));
export var MetricTypes;
(function (MetricTypes) {
    MetricTypes["simple"] = "simple";
    MetricTypes["relative"] = "relative";
})(MetricTypes || (MetricTypes = {}));
export var MetricTemplateRanges;
(function (MetricTemplateRanges) {
    MetricTemplateRanges["NORMAL"] = "normal";
    MetricTemplateRanges["HIGH"] = "high";
    MetricTemplateRanges["VERY_HIGH"] = "very high";
})(MetricTemplateRanges || (MetricTemplateRanges = {}));
export var ScrollElements;
(function (ScrollElements) {
    ScrollElements["scenarioDetails"] = "scenarioDetails";
    ScrollElements["editConfiguration"] = "editConfiguration";
    ScrollElements["editMetric"] = "editMetric";
    ScrollElements["problemStatement"] = "problemStatement";
    ScrollElements["scenarioList"] = "scenarioList";
    ScrollElements["resultSetsList"] = "resultSetsList";
    ScrollElements["resultSetsDetails"] = "resultSetsDetails";
    ScrollElements["rsWorkspaceScenario"] = "rsWorkspaceScenario";
    ScrollElements["recipeLiquidDialog"] = "recipeLiquidDialog";
    ScrollElements["editRecipeStepDialog"] = "editRecipeStepDialog";
    ScrollElements["rsWorkspaceTimeframeDialog"] = "rsWorkspaceTimeframeDialog";
    ScrollElements["rsWorkspaceResultSet"] = "rsWorkspaceResultSet";
})(ScrollElements || (ScrollElements = {}));
export var BioreactorStateProcessVariables;
(function (BioreactorStateProcessVariables) {
    BioreactorStateProcessVariables["FillVolume"] = "FillVolume";
    BioreactorStateProcessVariables["GassingRateAbs"] = "GassingRateAbs";
    BioreactorStateProcessVariables["GassingRateProp"] = "GassingRateProp";
    BioreactorStateProcessVariables["StirSpeed"] = "StirSpeed";
    BioreactorStateProcessVariables["VCD"] = "VCD";
    BioreactorStateProcessVariables["TCD"] = "TCD";
    BioreactorStateProcessVariables["O2Rate"] = "O2Rate";
    BioreactorStateProcessVariables["CO2Rate"] = "CO2Rate";
    BioreactorStateProcessVariables["N2Rate"] = "N2Rate";
})(BioreactorStateProcessVariables || (BioreactorStateProcessVariables = {}));
export var PhysicsAndChemistryProcessVariables;
(function (PhysicsAndChemistryProcessVariables) {
    PhysicsAndChemistryProcessVariables["DO"] = "DO";
    PhysicsAndChemistryProcessVariables["PpCO2"] = "PpCO2";
    PhysicsAndChemistryProcessVariables["PH"] = "PH";
    PhysicsAndChemistryProcessVariables["Buffering"] = "Buffering";
    PhysicsAndChemistryProcessVariables["Temperature"] = "Temperature";
})(PhysicsAndChemistryProcessVariables || (PhysicsAndChemistryProcessVariables = {}));
export var BioprocessParametersProcessVariables;
(function (BioprocessParametersProcessVariables) {
    BioprocessParametersProcessVariables["TipSpeed"] = "TipSpeed";
    BioprocessParametersProcessVariables["PowerInput"] = "PowerInput";
    BioprocessParametersProcessVariables["SpecificPowerInput"] = "SpecificPowerInput";
    BioprocessParametersProcessVariables["KlaO2"] = "KlaO2";
    BioprocessParametersProcessVariables["KlaCO2"] = "KlaCO2";
    BioprocessParametersProcessVariables["MixingTime"] = "MixingTime";
    BioprocessParametersProcessVariables["SuperficialGasVelocity"] = "SuperficialGasVelocity";
    BioprocessParametersProcessVariables["ReynoldsNumber"] = "ReynoldsNumber";
})(BioprocessParametersProcessVariables || (BioprocessParametersProcessVariables = {}));
export var CellStatusProcessVariables;
(function (CellStatusProcessVariables) {
    CellStatusProcessVariables["CellActivity"] = "CellActivity";
    CellStatusProcessVariables["MetabolicState"] = "MetabolicState";
})(CellStatusProcessVariables || (CellStatusProcessVariables = {}));
export var NutrientsGenericProcessVariables;
(function (NutrientsGenericProcessVariables) {
    NutrientsGenericProcessVariables["PrimaryCarbonSource"] = "PrimaryCarbonSource";
    NutrientsGenericProcessVariables["SecondaryCarbonSource"] = "SecondaryCarbonSource";
    NutrientsGenericProcessVariables["TertiaryCarbonSource"] = "TertiaryCarbonSource";
    NutrientsGenericProcessVariables["CarbonIntermediate"] = "CarbonIntermediate";
    NutrientsGenericProcessVariables["CarbonSecondaryIntermediate"] = "CarbonSecondaryIntermediate";
    NutrientsGenericProcessVariables["PrimaryNitrogenSource"] = "PrimaryNitrogenSource";
    NutrientsGenericProcessVariables["ConjugateNitrogenSource"] = "ConjugateNitrogenSource";
    NutrientsGenericProcessVariables["Toxin"] = "Toxin";
    NutrientsGenericProcessVariables["Product"] = "Product";
    NutrientsGenericProcessVariables["ToxicProduct"] = "ToxicProduct";
    NutrientsGenericProcessVariables["Inducer"] = "Inducer";
    NutrientsGenericProcessVariables["Base"] = "Base";
    NutrientsGenericProcessVariables["Acid"] = "Acid";
})(NutrientsGenericProcessVariables || (NutrientsGenericProcessVariables = {}));
export var NutrientsSpecificProcessVariables;
(function (NutrientsSpecificProcessVariables) {
    NutrientsSpecificProcessVariables["Glucose"] = "Glucose";
    NutrientsSpecificProcessVariables["Lactate"] = "Lactate";
    NutrientsSpecificProcessVariables["Glutamine"] = "Glutamine";
    NutrientsSpecificProcessVariables["Glutamate"] = "Glutamate";
    NutrientsSpecificProcessVariables["AminoAcidGeneric"] = "AminoAcidGeneric";
    NutrientsSpecificProcessVariables["Ammonium"] = "Ammonium";
    NutrientsSpecificProcessVariables["Alcohol"] = "Alcohol";
})(NutrientsSpecificProcessVariables || (NutrientsSpecificProcessVariables = {}));
export var ProcessVariableCategoryTypes;
(function (ProcessVariableCategoryTypes) {
    ProcessVariableCategoryTypes["BioreactorState"] = "BioreactorState";
    ProcessVariableCategoryTypes["PhysicsAndChemistry"] = "PhysicsAndChemistry";
    ProcessVariableCategoryTypes["BioprocessParameters"] = "BioprocessParameters";
    ProcessVariableCategoryTypes["CellStatus"] = "CellStatus";
    ProcessVariableCategoryTypes["NutrientsGeneric"] = "NutrientsGeneric";
    ProcessVariableCategoryTypes["NutrientsSpecific"] = "NutrientsSpecific";
    ProcessVariableCategoryTypes["RecipeVariables"] = "RecipeVariables";
})(ProcessVariableCategoryTypes || (ProcessVariableCategoryTypes = {}));
